











import Vue from "vue";
import { Decision } from "@megarax/client/src/resources/Decision";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";

const validationRules = {
  title: required,
  description: required,
};

export default createComponent({
  name: "DecisionFrom",
  components: {},
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
  setup() {
    return {
      ...formValidator(),
      validationRules,
    };
  },
});
